import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";
import { Link } from "@reach/router";

function Fly(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            You hear as I fly around the back of your neck and past your right
            ear. "I'm a Blow Fly and we flies do have our uses
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              what else are the fly family useful for?"
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "You humans might not like the thought, but we{" "}
            <a href="http://urbanpollinators.blogspot.com/2014/03/flies-forgotten-pollinators.html">
              {" "}
              pollinate
            </a>{" "}
            a lot of the crops that you rely on for your food and drink. We
            might not be as photogenic, but we help to pollinate hops in beer,
            apples in cider and grapes in wine, so, Cheers so next time you
            raise a glass, think of us and say cheers!
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              Can you think of anything else us flies help with?"
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Our tiny babies, our lovely maggots were used to treat gangrenous
            wounds without antibiotics. This method was used during the American
            Civil War. Sheeps blowfly larvae can be used to treat diabetic
            ulcers, bedsores and other wounds in humans, by applying our larvae
            to the affected area. Our little un's eat the infected tissue
            cleansing the wound with their antibacterial saliva and speeding up
            new tissue growth. Sacrificing our children to heal your human
            wounds? You're welcome! Also, not to boast but Horseflies are great
            pollinators because they are so hairy."
          </p>
        </div>
      </div>
    );
  }
}

export default Fly;
